module.exports = "<div ng-class=\"{\t&quot;cui-radio_checked&quot;: radio.isChecked(),\t&quot;cui-radio_inline&quot;: radio.typeIsInline()}\" class=\"cui-radio\"><label ng-transclude=\"ng-transclude\" class=\"cui-radio__label\"></label></div>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/radio-wrapper/template.jade
// module id = 826
// module chunks = 0